import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { BalanceSheetView } from "./balanceSheet-view"
import { data } from "jquery";
import moment from "moment";

export class BalanceSheetViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'لیست بدهکاران و بستانکاران';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.balances = ObservableArray.create<singleBalance>();
        this.date = moment.utc();
    }
    GetDefaultView(): View <ViewModel> {
        return new BalanceSheetView();
    }
    public getTypeId(): string {
        return "VM-FB9670D4-3B17-4BA4-A038-22FF11EADCA8"
    }

    public set balances(v: ObservableArray<singleBalance>) { this._balances = v; } public get balances(): ObservableArray<singleBalance> { return this._balances;} private _balances: ObservableArray<singleBalance>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/GetBalanceSheet',{
                At : this.date.clone()
            });
            this.balances.update(...result.FoundParticipants.map((x,i)=>{
                let r = new singleBalance(this);
                r.index = i+1;
                r.participantCode = x.Code;
                r.participantId = x.Id;
                r.participantName = x.Name;
                r.totalCredit = x.TotalCredit;
                r.totalDebt = x.TotalDebt;
                r.totalBalance = x.TotalBalance;
                r.credit = x.Credit;
                return r;
            }))
            // return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            // return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }


}

export class singleBalance extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set participantId(v: string) { this._participantId = v; } public get participantId(): string { return this._participantId;} private _participantId: string;
    public set participantName(v: string) { this._participantName = v; } public get participantName(): string { return this._participantName;} private _participantName: string;
    public set participantCode(v: string) { this._participantCode = v; } public get participantCode(): string { return this._participantCode;} private _participantCode: string;
    public set totalCredit(v: number) { this._totalCredit = v; } public get totalCredit(): number { return this._totalCredit;} private _totalCredit: number;
    public set totalDebt(v: number) { this._totalDebt = v; } public get totalDebt(): number { return this._totalDebt;} private _totalDebt: number;
    public set totalBalance(v: number) { this._totalBalance = v; } public get totalBalance(): number { return this._totalBalance;} private _totalBalance: number;
    public set credit(v: number) { this._credit = v; } public get credit(): number { return this._credit;} private _credit: number;
    
}


